/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/content-addon/custom-elements';

import { defineCustomElement as defineOsdsContentAddon } from '@ovhcloud/ods-stencil/components/content-addon/custom-elements/osds-content-addon.js';

export const OsdsContentAddon = /*@__PURE__*/createReactComponent<JSX.OsdsContentAddon, HTMLOsdsContentAddonElement>('osds-content-addon', undefined, undefined, defineOsdsContentAddon);
